// extracted by mini-css-extract-plugin
export default {"icon":"click-and-collect-store-icon_icon__2f9f5","small":"click-and-collect-store-icon_small__2fa0b","promoted":"click-and-collect-store-icon_promoted__f5530"};